import { useSelector } from "react-redux";
import OverviewHeader from "../../../components/overviewHeader";
import { RootState } from "../../../state/store";

interface HeaderSectionProps {
  dashboardDisplayName: string;
  refreshDashboard: () => void;
}

const HeaderSection = ({ dashboardDisplayName, refreshDashboard }: HeaderSectionProps) => {
  const { company_details } = useSelector((state: RootState) => state.company);
  const isMaintenance = company_details?.maintenance_mode?.enabled;

  return (
    <OverviewHeader
      dashboardTitle={dashboardDisplayName}
      refreshData={refreshDashboard}
      isMaintenance={isMaintenance ?? false}
    />
  );
};

export { HeaderSection };
